import React, {Component}   from 'react';
import {
	Panel,
	Modal,
	FormGroup,
	ControlLabel,
	InputGroup,
	Row,
	Col,
	Button,
	ProgressBar
}                           from 'react-bootstrap'
import axios                from "axios";
import FileSaver            from 'file-saver';
import moment               from "moment";
import DateTime             from "react-datetime";
import socketIOClient       from "socket.io-client";
import {
	ToastContainer,
	toast
  }                         from "react-toastify";

import CrudComponent        from './../zynappse-crud'
import var1                 from '../schema/RedemptionLog.json'
import                           './style.less';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';

import saveTrail            from '../../utils/saveTrail';

import {
	IS_VALID
}                           from "utils";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class Redemption extends Component {
	constructor (props) {
		super(props);

		this.exportComponentRef = React.createRef();

		this.state = {
			showModal: false
		};

		this.accessible = this.accessible.bind(this);
	}

	accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

	render() {
		let {access} = this.props.accessjson;

		var redemption = [
			{ method: 'descending', column: 'redemptionDate' }
		];

		const isUndefined = (obj) => typeof obj === 'undefined' ? true : false;

		var user = Parse.User.current();

		if (!isUndefined(user) && user !== null) {
			if (!isUndefined(user.get('userType'))) {
	      if (user.get('userType').toUpperCase() === 'MERCHANT') {
					if (!isUndefined(user.get('Merchant'))) {
						redemption[0] = { method: 'equalTo', column: 'merchantName', value: user.get('Merchant').get('name') }
					}
	      }
	    }
		}

		let isExportAccessible = this.accessible("EXPORT");

		let crudProps = {
			schema: var1,
			moduleQuery: redemption,
			access: access,
			saveTrail: saveTrail,
			additionalButtons: [
				{
					style: { display: isExportAccessible },
					disabledState: false,
					func: () => {
						if (isExportAccessible === "") {
							this.setState({ showModal: true });
						}
					},
					loaderState: false,
					label: "EXPORT"
				}
			]
		};

		return (
			<Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>{var1.classNameLabel.toUpperCase()}</h4>
				</Panel.Heading>
				<Panel.Body>
					<CrudComponent {...crudProps} />
					<Modal
						show={this.state.showModal}
						onHide={() => {
							if (
								this.exportComponentRef.current &&
								this.exportComponentRef.current.isLoading()
							) {
								return;
							}

							this.setState({ showModal: false });
						}}
					>
						<Modal.Header closeButton>
							<Modal.Title>EXPORT REDEMPTION</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<ExportComponent
									ref={this.exportComponentRef}
									closeModal={() => {
										this.setState({ showModal: false });
									}}
							/>
						</Modal.Body>
					</Modal>
					<ToastContainer />
				</Panel.Body>
			</Panel>
		);
	}
}


class ExportComponent extends Component {
	constructor (props) {
		super(props);

		this.state = {
			startDate: "",
			endDate: "",

			isExportStarting: false,
			isExporting: false,
			isExportSuccess: false,
			isExportError: false,
			exportPercentage: 0,
			fileConfig: {
				filename: "",
				blob: ""
			},
			errorMessage: ""
		};

		this.isLoading = this.isLoading.bind(this);
		this.exportData = this.exportData.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
	}

	isLoading () {
		let {
			isExportStarting,
			isExporting
		} = this.state;
	
		return isExportStarting || isExporting;
	}

	exportData () {
		let {
			startDate,
			endDate
		} = this.state;

		if (!IS_VALID(startDate)) {
			toast.error("Start Date is required.");
		} else if (!moment(startDate).isValid()) {
			toast.error("Please select a valid Start Date.");
		} else if (!IS_VALID(endDate)) {
			toast.error("End Date is required.");
		} else if (!moment(endDate).isValid()) {
			toast.error("Please select a valid End Date ");
		} else {
			this.setState({
				isExportStarting: true
			});

			axios.post(
				WEB_PATH + "/RedemptionLog/reports",
				{
					startDate: moment(startDate).startOf("day").format(),
					endDate: moment(endDate).endOf("day").format()
				},
				{
					timeout: 30000
				}
			)
			.then((res) => {
				let {
					fileName,
					socketNspId
				} = res.data;
				  
				this.setState({
					isExportStarting: false,
					isExporting: true
				});

				let io = socketIOClient(
					WEB_PATH,
					{
					  transports: ["websocket"],
					  path: "/socket.io",
					  query: {
						nspId: socketNspId
					  },
					  secure: true
					}
				);

				io.on(
					"export-redemption-logs-socket",
					(data) => {
						let {
							status,
							progress,
							fileName,
							message
						} = data;
		  
						if (status === "PROGRESS") {
							this.setState({
								exportPercentage: progress
							});
						} else if (status === "DONE") {
							this.setState({
								exportPercentage: 100
							});
			
							io.off("export-redemption-logs-socket");
							io.close();
							
							axios.get(
								WEB_PATH + '/RedemptionLog/download/' + fileName,
								{
									responseType: "arraybuffer"
								}
							)
							.then((res2) => {
								let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
									filename = `Redemption ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;
				
								this.setState({
									isExporting: false,
									isExportSuccess: true,
									exportPercentage: 100,
									fileConfig: {
										filename: filename,
										blob: blob
									}
								});
				
								FileSaver.saveAs(blob, filename);
							})
							.catch((err) => {
								let errorMessage = err.message;
				
								if (
									err.response &&
									err.response.data &&
									("TextDecoder" in window)
								) {
									let enc = new TextDecoder("utf-8");
									let arr = new Uint8Array(err.response.data);
									
									let data = JSON.parse(enc.decode(arr)) || {};
				
									if (
										data.error &&
										data.error.message
									) {
										errorMessage = data.error.message;
									}
								}
								
								this.setState({
									isExporting: false,
									isExportError: true,
									errorMessage
								});
							});
						} else if (status === "ERROR") {
							io.off("export-redemption-logs-socket");
							io.close();
							
							this.setState({
								isExporting: false,
								isExportError: true,
								errorMessage: message
							});
						}
					}
				);
			})
			.catch((err) => {
				let errorMessage = err.message;

				if (
				  err.response &&
				  err.response.data &&
				  typeof err.response.data === "string"
				) {
				  errorMessage = err.response.data;
				}
		
				this.setState({
				  isExportStarting: false,
				  isExportError: true,
				  errorMessage
				});
			});
		}
	}

	downloadFile () {
		let {
		  	fileConfig
		} = this.state;
	
		let {
			filename,
			blob
		} = fileConfig
	
		if (IS_VALID(filename) && IS_VALID(blob)) {
		  	FileSaver.saveAs(blob, filename);
		}
	}

	render () {
		let {
			startDate,
			endDate,

			isExportStarting,
			isExporting,
			isExportSuccess,
			isExportError,
			exportPercentage,
			errorMessage
		} = this.state;

		let {
			closeModal
		} = this.props;

		return (
			<div>
				{
					!isExporting &&
					!isExportSuccess &&
					!isExportError ? (
						[
							<p>Exporting of Redemption may take some time depending on the number of records.</p>,
							<br/>,
							<Row>
								<Col mdOffset={2} md={8}>
									<FormGroup>
										<ControlLabel>Date Coverage</ControlLabel>
										<InputGroup>
											<DateTime
												dateFormat="MMM DD, YYYY"
												timeFormat={false}
												value={startDate}
												onChange={(datetime) => {
													this.setState({ startDate: datetime });
												}}
												inputProps={{
													placeholder: "MMM DD, YYY",
													style: {
														borderTopRightRadius: 0,
														borderBottomRightRadius: 0
													},
													disabled: isExportStarting
												}}
											/>
											<InputGroup.Addon>to</InputGroup.Addon>
											<DateTime
												dateFormat="MMM DD, YYYY"
												timeFormat={false}
												value={endDate}
												onChange={(datetime) => {
													this.setState({ endDate: datetime });
												}}
												inputProps={{
												placeholder: "MMM DD, YYY",
												style: {
													position: "initial",
													borderRadius: "0 4px 4px 0"
												},
												disabled: isExportStarting
												}}
											/>
										</InputGroup>
									</FormGroup>
								</Col>
							</Row>,
							<div style={{ textAlign: "center" }}>
								<Button
									bsStyle="primary"
									disabled={isExportStarting}
									onClick={() => {
										this.exportData()
									}}
								>
									EXPORT
								</Button>
							</div>
						]
					) : (
						""
					)
				}

				{
					isExporting ? (
						[
							<p>This may take some time depending on the number of records.</p>,
							<ProgressBar
								active
								striped
								bsStyle="success"
								now={exportPercentage}
								label={`${exportPercentage}%`}
							/>
						]
					) : isExportSuccess || isExportError ? (
						isExportSuccess ? (
							<div style={{ textAlign: "center" }}>
								<Button
									bsStyle="success"
									content="DOWNLOAD FILE"
									onClick={this.downloadFile}
								>
									DOWNLOAD FILE
								</Button>
							</div>
						) : (
							[
								<h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
								<h4>{errorMessage}</h4>,
								<div style={{ textAlign: "center" }}>
									<Button
										bsStyle="primary"
										onClick={() => {
											closeModal();
										}}
										>
										CLOSE
									</Button>
								</div>
							]
						)
					) : (
						""
					)
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	var {accessjson} = state;

	const props = {
		accessjson
	};
	return props;
}

export default connect(mapStateToProps)(Redemption);



// WEBPACK FOOTER //
// ./components/Redemption/index.js